import React from "react";

import { CompetitionPage } from "../../components/competition/index.js";

export default ({ match }) => <CompetitionPage clientNumber={match.params.clientNumber} slug={match.params.slug} />;
